import { render, staticRenderFns } from "./serviceFeeModal.vue?vue&type=template&id=123e9a3b&scoped=true"
import script from "./serviceFeeModal.vue?vue&type=script&lang=js"
export * from "./serviceFeeModal.vue?vue&type=script&lang=js"
import style0 from "./serviceFeeModal.vue?vue&type=style&index=0&id=123e9a3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123e9a3b",
  null
  
)

export default component.exports